.productDetailsContainer {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

/* .productDetailsContainer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(../../assets/images/line-3d-inside.png) center/cover no-repeat;
  filter: grayscale(100%);
  z-index: -1;
  background-position: center 3%;
} */

.carouselContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  margin: auto;
  text-align: center;
  position: relative;
}

.carouselButtons {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  position: relative;
  width: 1024px;
  height: 201px;
}

.carouselButtons::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(../../assets/webp/curve.webp) center/cover no-repeat;
  z-index: -1;
  background-position: center;
}

.buttonWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  transition: all 0.4s zoom;
  border-width: 0px, 0px, 0px, 0px;
}

.buttonWrapper:nth-child(1) {
  top: 22px;
  left: 177px;
}

.buttonWrapper:has(.carouselButton.active):nth-child(1) {
  top: 14px;
  left: 148px;
}

.buttonWrapper:nth-child(2) {
  top: -24px;
  left: 50%;
  transform: translate(-50%, 0);
}

.buttonWrapper:has(.carouselButton.active):nth-child(2) {
  top: -32px;
}

.buttonWrapper:nth-child(3) {
  top: 22px;
  right: 201px;
}

.buttonWrapper:has(.carouselButton.active):nth-child(3) {
  top: 14px;
  right: 177px;
}

.carouselButton {
  cursor: pointer;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: var(--background-color);
  z-index: 1; /* Ensure the button content is above the pseudo-element */
  transition: all 0.15s ease;
}

.carouselButton::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 50%;
  padding: 2px;
  background: linear-gradient(180deg, #858585 0%, #121212 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: -1; /* Ensure it stays behind the button */
}

.carouselButton.active {
  width: 64px;
  height: 64px;
  box-shadow: var(--box-shadow-1);
}

.carouselButton.active::before {
  display: none;
}

.carouselButtonName {
  margin-top: 10px;
  font-size: 16px;
}

.carouselButton.active + .carouselButtonName {
  font-weight: 700;
  font-size: 20px;
  line-height: 35px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--text-color-1);
}

.icon {
  height: 48px;
}

.carouselButton.active .icon {
  height: 52px;
}

.progressCircle {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(125deg);
}

.progressBackground {
  fill: none;
  stroke: #121212;
  stroke-width: 2;
}

.progressBar {
  fill: none;
  stroke: var(--primary-color);
  stroke-width: 2;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.1s linear;
}

.carouselContent {
  position: relative;
  height: 567px;
}

.carouselImage {
  height: 567px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: -25px;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.carouselImage.activeImage {
  opacity: 1;
}

@media (max-width: 990px) {
  .productDetailsContainer {
    min-height: unset;
  }
  .carouselContent,
  .carouselImage {
    height: 420px;
  }
}

@media (max-width: 720px) {
  .carouselButtons {
    width: 480px;
    height: 115px;
  }
  .carouselButton {
    height: 32px;
    width: 32px;
  }
  .carouselButton.active {
    height: 45px;
    width: 45px;
  }
  .icon {
    height: 28px;
  }
  .carouselButton.active .icon {
    height: 38px;
  }
  .buttonWrapper:nth-child(1) {
    top: 10px;
    left: 50px;
  }
  .buttonWrapper:nth-child(2) {
    top: -16px;
  }
  .buttonWrapper:nth-child(3) {
    top: 10px;
    right: 50px;
  }
  .buttonWrapper:has(.carouselButton.active):nth-child(1) {
    top: 2px;
    left: 38px;
  }
  .buttonWrapper:has(.carouselButton.active):nth-child(2) {
    top: -22.5px;
  }
  .buttonWrapper:has(.carouselButton.active):nth-child(3) {
    top: 5px;
    right: 38px;
  }
  .carouselButtonName {
    font-size: 11px;
    margin-top: 8px;
  }
  .carouselButton.active + .carouselButtonName {
    font-size: 13px;
    line-height: 100%;
    font-weight: 500;
  }
  .carouselContent,
  .carouselImage {
    height: 350px;
    top: 0px;
  }
}

@media (max-width: 600px) {
  .carouselContent,
  .carouselImage {
    height: 410px;
  }
}

@media (max-width: 400px) {
  .carouselContent,
  .carouselImage {
    height: 350px;
  }
  .buttonWrapper:first-child {
    top: 0px;
    left: 75px;
  }
  .buttonWrapper:has(.carouselButton.active):first-child {
    top: -8px;
    left: 65px;
  }
  .buttonWrapper:nth-child(3) {
    top: 0px;
    right: 75px;
  }
  .buttonWrapper:has(.carouselButton.active):nth-child(3) {
    top: -8px;
    right: 68px;
  }
}

@media (max-width: 350px) {
  .buttonWrapper:first-child  {
    top: 0px;
    left: 92px;
  }
  .buttonWrapper:nth-child(3) {
    top: 0px;
    right: 95px;
  }
  .buttonWrapper:has(.carouselButton.active):first-child {
    top: -8px;
    left: 88px;
  }
  .buttonWrapper:has(.carouselButton.active):nth-child(3) {
    top: -8px;
    right: 90px;
  }
  .carouselButtonName {
    font-size: 10px;
    margin-top: 8px;
  }
  .carouselButton.active + .carouselButtonName {
    font-size: 11px;
    line-height: 100%;
    font-weight: 500;
  }
  .carouselContent, .carouselImage {
    height: 300px;
    top: -5px;
}
}
